import { motion } from "framer-motion";
import { GraduationCap, Award } from "lucide-react";
import { EXPERIENCE, EDUCATION, AWARDS } from "../data/projects";
import { SectionHeading } from "./Portfolio";

export const Experience = () => (
  <section id="experience" data-testid="experience-section" className="bg-white py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeading eyebrow="Career" title="My Experience" />

      <div className="relative ml-2 border-l-2 border-[#212529]/10 pl-8 md:ml-4 md:pl-12">
        {EXPERIENCE.map((job, i) => (
          <motion.div
            key={job.role}
            data-testid={`experience-item-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative mb-12 last:mb-0"
          >
            <span className="absolute -left-[41px] top-1.5 h-4 w-4 rounded-full border-4 border-white bg-accent md:-left-[57px]" />
            <span className="text-xs font-medium uppercase tracking-[0.25em] text-accent">{job.dates}</span>
            <h3 className="mt-1 text-xl font-semibold text-[#212529] md:text-2xl">{job.role}</h3>
            <span className="mt-0.5 block text-sm font-normal text-[#6c757d]">{job.company}</span>
            <ul className="mt-3 space-y-1.5">
              {job.points.map((pt) => (
                <li key={pt} className="flex gap-3 text-sm leading-relaxed text-[#6c757d]">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-accent" />
                  {pt}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>

      <div className="mt-20 grid grid-cols-1 gap-12 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="mb-6 flex items-center gap-3 text-xl font-semibold text-[#212529]">
            <GraduationCap className="h-6 w-6 text-accent" /> Education
          </h3>
          <div className="space-y-5">
            {EDUCATION.map((e, i) => (
              <div key={e.degree} data-testid={`education-item-${i}`} className="border border-[#212529]/10 p-6 transition-colors duration-300 hover:border-accent">
                <span className="text-xs font-medium uppercase tracking-[0.25em] text-accent">{e.years}</span>
                <h4 className="mt-1 text-lg font-semibold text-[#212529]">{e.degree}</h4>
                <span className="text-sm text-[#6c757d]">{e.school}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <h3 className="mb-6 flex items-center gap-3 text-xl font-semibold text-[#212529]">
            <Award className="h-6 w-6 text-accent" /> Awards &amp; Recognition
          </h3>
          <div className="space-y-5">
            {AWARDS.map((a, i) => (
              <div key={a.title} data-testid={`award-item-${i}`} className="border border-[#212529]/10 p-6 transition-colors duration-300 hover:border-accent">
                <span className="text-xs font-medium uppercase tracking-[0.25em] text-accent">{a.year}</span>
                <h4 className="mt-1 text-lg font-semibold text-[#212529]">{a.title}</h4>
                <span className="text-sm text-[#6c757d]">{a.org}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
